import React, { useState } from "react";
import "./Connect.css";
import topImage from "../Assests/img38.jpg";
import bottomImage from "../Assests/img51.jpeg";
import { AiOutlineClose } from "react-icons/ai"; // Importing Close Icon

const Connect = () => {
  const [showModal, setShowModal] = useState(false);

  // Function to Open Modal
  const handleOpenModal = () => {
    setShowModal(true);
    document.body.style.overflow = "hidden"; // Disable Scrolling
  };

  // Function to Close Modal
  const handleCloseModal = () => {
    setShowModal(false);
    document.body.style.overflow = "auto"; // Enable Scrolling
  };

  return (
    <div className="connect-container">
      {/* ✅ Top Section */}
      <div className="top-section">
        <div className="top-text">
          <h3 className="subheading">OUR EXPERTISE</h3>
          <h1 className="main-heading">
            Expert care, <i>dedicated</i> to <i>elevating healthcare.</i>
          </h1>
          <p className="description">
            We are a team of experienced medical professionals and pharmacy
            experts with over 20 years in healthcare. At HospiPharma, we ensure
            excellence in pharmacy services, delivering optimal solutions for
            hospitals and enhancing healthcare accessibility.
          </p>
          <button className="cta-btn" onClick={handleOpenModal}>
            LEARN MORE
          </button>
        </div>
        <img src={topImage} alt="Helping Plants" className="top-image" />
      </div>

      {/* ✅ Bottom Section */}
      <div className="bottom-section">
        <img src={bottomImage} alt="Planting" className="bottom-image" />
        <div className="bottom-text">
          <h2>Trusted Pharmacy Solutions for Better Healthcare.</h2>
          <p>
            Discover reliable pharmacy solutions tailored for hospitals—join us
            to enhance healthcare services.
          </p>
          <form className="signup-form">
            <input type="text" placeholder="Name" />
            <input type="email" placeholder="Email" />
            <button type="submit">Connect Me</button>
          </form>
          <p className="privacy-text">
            We care about your privacy. Unsubscribe anytime.
          </p>
        </div>
      </div>

      {/* ✅ Modal (Popup) */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <div className="modal-close-icon" onClick={handleCloseModal}>
              <AiOutlineClose size={24} />
            </div>

            {/* Modal Title */}
            <h2 className="modal-title">OUR EXPERTISE</h2>

            {/* Large Description */}
            <p className="modal-description">
              ✅ **HospiPharma** has a team of highly skilled **medical
              professionals** and **pharmacy experts** with over **20 years of
              experience** in healthcare.  
              <br /><br />
              Our goal is to provide **seamless healthcare services** by
              ensuring optimal solutions for hospitals, enhancing accessibility,
              and improving patient care.  
              <br /><br />
              We believe in **delivering fast and affordable pharmacy solutions**
              that can benefit hospitals and patients in **Tier 2 & Tier 3 cities**.
              Our team works day and night to bridge the **urban-rural
              healthcare gap** and improve patient outcomes.
              <br /><br />
              ✅ **Our Mission:**  
              - Ensure **Affordable Healthcare**  
              - Expand Pharmacy Services to Remote Areas  
              - Deliver High-Quality Medicines & Solutions  
              - Build Stronger Healthcare Infrastructure  
              <br /><br />
              💎 **At HospiPharma, our mission is to build a better and healthier tomorrow.**
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Connect;
 